import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { bibShape, shelfItemShape, ugcCommentShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { UGC_CONTENT_TYPES } from '@bibliocommons/constants-ugc';
import { supportsUGCContentType } from '@bibliocommons/utils-ugc';

import DisplayHeading from '../../../shared/UGC/DisplayHeading';
import CommentDisplay from '../../../shared/UGC/CommentDisplay';

import './CommentInfo.scss';

export default class ShelfListItemCommentInfo extends BcReactComponent {
  render() {
    const {
      bib,
      item,
      owner,
      currentLibrary,
      localBranch,
      ownerCommentForBib,
      commentsTransactions,
      shelfTransactions,
      commentsActions,
      shelfActions
    } = this.props;

    if (ownerCommentForBib && supportsUGCContentType(UGC_CONTENT_TYPES.COMMENT, currentLibrary, localBranch)) {
      return (
        <div className="cp-shelf-list-item-comment-info">
          <DisplayHeading><FormattedMessage id="ugc_comment_display_label" /></DisplayHeading>
          <CommentDisplay
            bib={bib}
            shelfItem={item}
            owner={owner}
            comment={ownerCommentForBib}
            commentsTransactions={commentsTransactions}
            shelfTransactions={shelfTransactions}
            commentsActions={commentsActions}
            shelfActions={shelfActions} />
        </div>
      );
    }

    return null;
  }
}

ShelfListItemCommentInfo.propTypes = {
  bib: bibShape.isRequired,
  currentLibrary: ImmutablePropTypes.map.isRequired,
  item: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  localBranch: PropTypes.string,
  ownerCommentForBib: ugcCommentShape,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/CommentInfo/CommentInfo.jsx